<!--
 * @title: 页面名称
 * @Description: 
 * @Version: 2.0
 * @Autor: 研发三部
 * @Date: 2020-12-03 09:37:11
 * @LastEditors: jinzb
 * @LastEditTime: 2020-12-28 16:01:28
-->
<template>
    <div style="height: 100%;" class="ecolodical">
        <div class="content1">
            <div class="block" style="border1: rgb(129, 21, 218) 1px solid;">


                <div class="resource-title">
                    <!-- <i class="el-icon-minus title_icon"></i> -->
                    <span
                        style="height: 100%;font-weight: 800;color: #00ffff;font-size: 1.2vw;margin-left: 3%;">▎</span>草原退化情况
                </div>
                <dv-border-box-1 backgroundColor="rgba(14, 45, 40,0.5)" style="height: calc(100% - 40px);">
                    <div style="height: 100%;">

                        <div style="height: 100%;margin: 0 5%; ">
                            <div style="height: 100%;">
                                <v-chart :option="degradationChart" autoresize style="width:100%;height:100%" />
                            </div>
                        </div>

                    </div>

                </dv-border-box-1>
            </div>
            <div class="block">

                <div style=" height: 100%;width: 100%;border-radius: 10px; border1: pink 1px solid;">
                    <el-carousel :interval="6000" arrow="always" style="height: 100%">
                        <el-carousel-item v-for="item in mapImages" style="height: 100%">
                            <div class="image_title"></div>
                            <div style="width: 100%; height: 90%;position: relative;">

<el-image class="imageBox8" :preview-src-list="mapImages.map(ele=> ele.url)" :src=" item.url" fit="contain"
    style="width: 100%; height: 100%;">

</el-image>

<div style="position: absolute;top: -9%;left:  40%;" class="image_title"> {{ item.name
}} </div>



</div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
            <div class="block" style="border1: rgb(227, 192, 255) 1px solid;">
                <div class="resource-title">
                    <!-- <i class="el-icon-minus title_icon"></i> -->
                    <span style="height: 100%;font-weight: 800;color: #00ffff;font-size: 1.2vw;">▎</span>草原盖度
                </div>
                <dv-border-box-1 backgroundColor="rgba(14, 45, 40,0.5)" style="height: calc(100% - 40px);">
                    <div style="height: 100%;">
                        <div style="height: 100%;width: 90%;">
                            <div class="zhzb_title">
                                <div style="margin-left: 5%;">
                                    综合植被盖度<span>&nbsp;&nbsp;&nbsp;&nbsp; {{ avgCoverage }} %</span>
                                </div>
                            </div>
                            <div style="height: 80%;">
                                <div style="width: 100%;height: 90%;">
                                    <div style="width:100%;height:100%;margin-left: 5.5%;">

                                        <dv-scroll-board :key="scrollBoardKey" :config="vegetationCoverageTable"
                                            style="width:100%;height:100%" />
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>




                </dv-border-box-1>
            </div>
        </div>
        <div class="content2">
            <div class="resource-title">
                <!-- <i class="el-icon-minus title_icon"></i> -->
                <span
                    style="height: 100%;font-weight: 800;color: #00ffff;font-size: 1.2vw;margin-left: 0.8%;">▎</span>退化治理情况
            </div>
            <dv-border-box-1 backgroundColor="rgba(14, 45, 40,0.5)" style="height: calc(100% - 40px);">
                <div style="width:100%;height: 90%;display: flex;
    justify-content: space-around; " class="bottom_image">
                    <div style="margin-left: 0%;width: 28%;height:100%;text-align: center;">
                        <el-carousel :interval="3000" arrow="always" style="height: 90%;">
                            <el-carousel-item v-for="item in degenerationImage" style="height: 100%;">
                                <el-image class="imageBox4" :src=" item.url" fit="fit"
                                    style="width: 100%;height: 100%;margin-top: 5%;" @click="handlePictureCardPreview(item.url)"></el-image>
                                    <!-- <div style="position: absolute;top: 0;left: 0;font-size: 1vw;color: red;"> h:{{ h }};w:{{ w }}</div> -->
                                </el-carousel-item>
                        </el-carousel>
                        <div class="title_block">
                            <div class="pest_image_title">退化照片</div>
                        </div>

                    </div>
                    <div style="width: 28%;height:100%;text-align: center;">
                        <el-carousel :interval="3000" arrow="always" style="height: 90%;">
                            <el-carousel-item v-for="item in governImage" style="height: 100%;">
                                <el-image :src=" item.url" fit="fit"
                                    style="width: 100%;height: 100%;margin-top: 5%;" @click="handlePictureCardPreview(item.url)"></el-image>
                            </el-carousel-item>
                        </el-carousel>
                        <div class="title_block">
                            <div class="pest_image_title" >治理过程</div>
                        </div>
                    </div>
                    <div style="width: 28%;height:100%;text-align: center;">
                        <el-carousel :interval="3000" arrow="always" style="height: 90%;">
                            <el-carousel-item v-for="item in resultImage" style="height: 100%;">
                                <el-image :src=" item.url" fit="fit"
                                    style="width: 100%;height: 100%;margin-top: 5%;" @click="handlePictureCardPreview(item.url)"></el-image>
                            </el-carousel-item>
                        </el-carousel>
                        <div class="title_block">
                            <div class="pest_image_title">治理后</div>
                        </div>
                    </div>


                </div>

                <!-- <div style=" position: absolute; top: 0; left: 0; height: 100%;width: 100%;
    display: flex;
    justify-content: space-between;margin-top: 2%;">
                    <div style="height: 86%;width: 30%;margin-left:  2%;">
                        <div style="height: 100%;width: 100%;">
                            <el-carousel :interval="5000" arrow="always" style="height: 90%;">
                                <el-carousel-item v-for="item in 4" :key="item" style="height: 100%;">
                                    <el-image :src="require('@/assets/large-screen-img/gl.png')" fit="fit"
                                        style="width: 100%;height: 100%;"></el-image>
                                </el-carousel-item>
                            </el-carousel>
                            <div style="height: 1vw;text-align: center;font-size: 0.3vw;font-size: 1vw;
    font-weight: 600;padding: 1% 0;margin-bottom: 5%;">退化照片</div>
                        </div>
                    </div>
                    <div style="height: 86%;width: 30%;">
                        <div style="height: 100%;width: 100%;">
                            <el-carousel :interval="5000" arrow="always" style="height: 90%;">
                                <el-carousel-item v-for="item in 4" :key="item" style="height: 100%;">
                                    <el-image :src="require('@/assets/large-screen-img/gl.png')" fit="fit"
                                        style="width: 100%;height: 100%;"></el-image>
                                </el-carousel-item>
                            </el-carousel>
                            <div style="height: 1vw;text-align: center;font-size: 0.3vw;font-size: 1vw;
    font-weight: 600;padding: 1% 0;margin-bottom: 5%;">治理过程</div>
                        </div>
                    </div>
                    <div style="height: 86%;width: 30%; margin-right: 2%;">
                        <div style="height: 100%;width: 100%;">
                            <el-carousel :interval="5000" arrow="always" style="height: 90%;">
                                <el-carousel-item v-for="item in 4" :key="item" style="height: 100%;">
                                    <el-image :src="require('@/assets/large-screen-img/gl.png')" fit="fit"
                                        style="width: 100%;height: 100%;"></el-image>
                                </el-carousel-item>
                            </el-carousel>
                            <div style="height: 1vw;text-align: center;font-size: 0.3vw;font-size: 1vw;
    font-weight: 600;padding: 1% 0;margin-bottom: 5%;">治理后</div>
                        </div>
                    </div>

                </div> -->

            </dv-border-box-1>
        </div>


        <el-dialog :visible.sync="dialogVisible" @close="closeDialogImage" modal-append-to-body append-to-body >
        <div style="position: relative;" class="image_dialog">
          <img width="100%" :src="dialogImageUrl" alt="" />
       <el-button class="closeButton" style="z-index: 10;"  circle @click="closeDialogImage">
                    <i class="el-icon-close"></i>
                </el-button>

        </div>
       
     </el-dialog>

    </div>
</template>
<script>

import leftTop from "../comp/shouye/leftTop.vue";
import leftBottom from "../comp/shouye/leftBottom.vue";
import rightBottom from "../comp/shouye/rightBottom.vue";
import rightTop from "../comp/shouye/rightTop.vue";

import * as api from "@/api/cloud-screen";
import CFG from "@/config/config";


export default {
    components: { leftTop, leftBottom, rightBottom, rightTop },
    props: {
        show: {
            type: Boolean,
            default: true
        },
        maptype: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            w:0,
            h:0,
            w1: 0,
            h1: 0,
            dialogImageUrl:'',
        dialogVisible: false, //预览是否可见

            degradationChart: {
                legend: {

                    type: "scroll",
                    textStyle: {
                        color: "#fbfffd"
                    },
                    pageIconColor: "#00FFFF",
                    pageTextStyle: {
                        color: "#00FFFF"
                    },
                    bottom: "60",
                    icon: 'circle',
                    itemWidth:20,
                    padding: [5, 0]

                },
                grid: {
                    left: "40px",
                    right: "40px",
                    bottom: "190px",
                    top: "10px",
                    containLabel: true
                },
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}: {c}万亩<br/>占比： {d}%"
                },
                series: [
                    {
                        name: "草原退化",
                        type: "pie",
                        radius: ["0", "40%"],
                        center: ["50%", "40%"],

                        itemStyle: {
                            color: "#c23531",
                            shadowBlur: 200,
                            shadowColor: "rgba(0, 0, 0, 0.5)"
                        },
                        animationType: "scale",
                        animationEasing: "elasticOut",
                        label: {
                            fontSize: 10,
                            normal: {
                                // formatter: "{c|{c}万亩}\n {d|{d}%}",
                                formatter: "{c|{c}}\n {d|{d}%}",
                                rich: {
                                    c: {
                                        color: "#fff"
                                    },
                                    d: {
                                        color: "#00ffe4"
                                    }
                                }
                            }
                        },
                        labelLine: {
                            normal: {
                                show: true,
                                length: 1
                            }
                        },
                        data: [],
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    var colorList = {
                                        "无退化": "#A3FF73",
                                        "轻度退化": "#FFEBAF",
                                        "中度退化": "#F5CA7A",
                                        "重度退化": "#CDAA66",
                                    };
                                    let color = colorList[params.name] ? colorList[params.name] : "#a3ff73"
                                    return color;
                                }
                            }
                        }
                    }
                ]
            },

            mapImages: [],
            urlprefix: CFG.LOTIP,
            degenerationImage: [],
            governImage: [],
            resultImage: [],
            avgCoverage: "-",
            vegetationCoverageTable: {
                header: [],
                data: [],
                headerBGC: "rgba(14, 45, 40,0.8)",
                oddRowBGC: "rgba(14, 45, 40,0.59)",
                evenRowBGC: "rgba(14, 45, 40,0.59)",
                align: ['center', 'center']
            },
            scrollBoardKey: 0

        };
    },
    async mounted() {
    //     setInterval(() => {
    //   this.getH()
    //   this.getW()
    //   this.getH1()
    //         this.getW1()
    // }, 5000);
        let that = this
        window.addEventListener('resize', () => {

            this.$nextTick(() => {
                that.scrollBoardKey = that.scrollBoardKey + 1
            })
        })
        console.log(this.$route.query);
        console.log(this.$route.params.systemSid);

        console.log(this.conf, "conf=================");

        // setTimeout(() => {
        //   console.log(this.conf,"conf=================")

        //           }, 5000);

        let data = await api.getConfig(this.$route.params.systemSid);
        console.log(data, "mmmmmmmmmmmm");
        if (data.resp_code == "10000") {
            this.conf = data.data;
        }

        // this.getAreaAndType();
        // this.getRangelandChart();
        // this.getGrasslandClassChart();
        this.getDegradationChart();
        this.getVegetationCoverageTable();

        if (this.$route.query) {

            if (this.$route.query["ecologicalMapImage"]) {
                this.mapImages = JSON.parse(this.$route.query["ecologicalMapImage"]);
            } else {
                if (this.conf && this.conf["ecologicalMapImage"]) {
                    this.mapImages = JSON.parse(this.conf["ecologicalMapImage"]);
                } else {
                    this.mapImages = [];
                }
            }

            if (this.$route.query["degenerationImage"]) {
                this.degenerationImage = JSON.parse(this.$route.query["degenerationImage"]);
            } else {
                if (this.conf && this.conf["degenerationImage"]) {
                    this.degenerationImage = JSON.parse(this.conf["degenerationImage"]);
                } else {
                    this.degenerationImage = [];
                }
            }

            if (this.$route.query["governImage"]) {
                this.governImage = JSON.parse(this.$route.query["governImage"]);
            } else {
                if (this.conf && this.conf["governImage"]) {
                    this.governImage = JSON.parse(this.conf["governImage"]);
                } else {
                    this.governImage = [];
                }
            }

            if (this.$route.query["resultImage"]) {
                this.resultImage = JSON.parse(this.$route.query["resultImage"]);
            } else {
                if (this.conf && this.conf["resultImage"]) {
                    this.resultImage = JSON.parse(this.conf["resultImage"]);
                } else {
                    this.resultImage = [];
                }
            }
        } else {
            if (this.conf) {

                if (this.conf["ecologicalMapImage"]) {
                    this.mapImages = JSON.parse(this.conf["ecologicalMapImage"]);
                } else {
                    this.mapImages = [];
                }

                if (this.conf["degenerationImage"]) {
                    this.degenerationImage = JSON.parse(this.conf["degenerationImage"]);
                } else {
                    this.degenerationImage = [];
                }

                if (this.conf["governImage"]) {
                    this.governImage = JSON.parse(this.conf["governImage"]);
                } else {
                    this.governImage = [];
                }

                if (this.conf["resultImage"]) {
                    this.resultImage = JSON.parse(this.conf["resultImage"]);
                } else {
                    this.resultImage = [];
                }
            }
        }


    },
    methods: {
        getW1() {
            this.w1 = document.getElementsByClassName('imageBox8')[0].clientWidth
        },

        getH1() {
            this.h1 = document.getElementsByClassName('imageBox8')[0].clientHeight
        },
        getW() {
      this.w = document.getElementsByClassName('imageBox4')[0].clientWidth
    },

    getH() {
      this.h = document.getElementsByClassName('imageBox4')[0].clientHeight
    },
        handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    closeDialogImage() {
      this.dialogImageUrl = "";
      this.dialogVisible = false;
    },
        getVegetationCoverageTable() {
            api.getVegetationCoverageTable(this.$route.params.systemSid).then((res) => {
                if (res.resp_code == "10000") {
                    this.vegetationCoverageTable.data = res.data.data;
                    this.vegetationCoverageTable.header = res.data.header;
                    this.vegetationCoverageTable = { ...this.vegetationCoverageTable }
                    this.avgCoverage = res.data.avgCoverage
                        ? res.data.avgCoverage.avgCoverage.toFixed(2)
                        : "-";
                }
            });
        },
        getDegradationChart() {
            api.getDegradationChart(this.$route.params.systemSid).then((res) => {
                if (res.resp_code == "10000") {
                    // this.degradationChart.xData = res.data.legend;
                    let obj = [
                        { name: "无退化", value: 0 },
                        { name: "轻度退化", value: 0 },
                        { name: "中度退化", value: 0 },
                        { name: "重度退化", value: 0 }
                    ]
                    if (res.data.data) {
                        res.data.data.forEach((item) => {
                            if (item.name == "无退化") {
                                obj[0].value = item.value.toFixed(2)
                            } else if (item.name == "轻度退化") {
                                obj[1].value = item.value.toFixed(2)
                            } else if (item.name == "中度退化") {
                                obj[2].value = item.value.toFixed(2)
                            } else if (item.name == "重度退化") {
                                obj[3].value = item.value.toFixed(2)
                            }
                        });
                    }
                    this.degradationChart.series[0].data = obj;
                    this.degradationArea = res.data.area ? res.data.area.sum.toFixed(2) : "-";
                }
            });
        },
    }
};
</script>
  
  
<style lang="scss"  scoped>
   .image_dialog  .closeButton{
    width: 45px;
    height: 45px;
    background-color: rgba(0,0,0,.4) !important;
    font-size: 1.5vw;
    font-weight: 600;
    position: absolute;
    top: 2%;
    right: 2%;
    border: none;
    outline: 0;
    padding: 0;
    margin: 0;
}
 /deep/ .el-dialog__header{
 padding: 0 0 !important;
  }
  /deep/ .el-dialog__body{
    padding: 0 0 !important;
  }
.bottom_image /deep/ .el-carousel__indicators--horizontal{
    display: none;
}
.zhzb_title {
    height: 20%;
    font-size: 1vw;
    font-weight: 500;
    color: #fff;
    display: flex;
    align-items: center;
}

.title_block {
    height: 10%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pest_image_title {
    // display: inline-block;
    // height: 100%;
    // line-height: 10%;

    color: #fff;
    font-size: 0.9vw;
    font-weight: 800;
    // padding: 3% 0;

}

.content1 {
    //   display: flex;
    // justify-content: space-between;
    // background-color: red;
    display: grid !important;
    grid-template-columns: 4fr 7fr 4fr !important;
    // padding-top: 90px;
    // height: calc(60% - 60px);
    height: 60%;

    // border: 1px red solid;
    .block {

        height: 100%;
        // background-color: #00ffff;

    }
}

.content2 {
    // border: 1px white solid;
    height: calc(40%);
}

/deep/ .el-carousel__arrow {
    font-weight: 800;
    font-size: 2vw;
    line-height: 2vw;
}

/deep/ .el-carousel__container {
    height: 100%;
}

.image_title {
    font-style: oblique;
    text-align: center;
    color: #fff;
    font-size: 1.5vw;
    height: 10%;
    line-height: 40px;
    font-weight: 500;
    text-shadow: 0 0 5px #000000, 0 0 5px #000000, 0 0 5px #000000;
}

.title_icon {
    transform: rotate(90deg);
    font-weight: 700;
    color: #00ffff;
}

.resource-title {
    color: #fff;
    font-size: 1.5vw;
    height: 40px;
    line-height: 40px;
    // margin: 4px 0;
    font-weight: 500;
    text-shadow: 0 0 5px #000000, 0 0 5px #000000, 0 0 5px #000000;
}

.image_base {
    width: 100%;
    height: 100%;
    padding: 16px 16px 0 16px;
    background-image: url("../../../assets/large-screen-img/ditu.png");
    background-size: cover;
    background-position: center center;
}
</style>
  
<style >
.el-image-viewer__mask{
 opacity: 1 !important;
   background: #fff !important;
}
</style>